import { Injectable, DOCUMENT, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private document = inject(DOCUMENT);
  private isDarkTheme = new BehaviorSubject<boolean>(false);
  
  isDarkTheme$ = this.isDarkTheme.asObservable();

  constructor() {
    // Verificar si hay una preferencia guardada en localStorage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      this.setTheme(savedTheme === 'dark');
    } else {
      // Usar la preferencia del sistema si no hay tema guardado
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.setTheme(prefersDark);
    }
  }

  toggleTheme(): void {
    const newTheme = !this.isDarkTheme.value;
    this.setTheme(newTheme);
  }

  setTheme(isDark: boolean): void {
    this.isDarkTheme.next(isDark);
    
    // Guardar la preferencia en localStorage
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    
    // Aplicar o quitar la clase de tema oscuro
    if (isDark) {
      this.document.documentElement.classList.add('p-dark');
    } else {
      this.document.documentElement.classList.remove('p-dark');
    }
  }

  getCurrentTheme(): boolean {
    return this.isDarkTheme.value;
  }
}